<template>
  <div class="pattern-block tutorial" :class="`size-3`">
    <div class="description-box">
      <span>{{ steps[step].description }}</span>
    </div>
    <div class="time-box">
      <div v-if="steps[step].countDown" :style="gradient" class="time">
        <span>{{ steps[step].countDown }}</span>
      </div>
    </div>

    <div v-for="row in 3" :key="`row${row}`" class="row">
      <div v-for="column in 3" :key="`column${column}`" class="column">
        <div
          v-if="isMarked(row, column)"
          @click="reload ? null : touchBlock(row, column)"
          class="item number"
          :class="[
            {
              mark: steps[step].showMark && isMarked(row, column),
            },
            {
              fail: isFail(row, column),
            },
          ]"
        >
          <span v-if="isNumber(row, column)">{{ isNumber(row, column) }}</span>
        </div>
        <div v-else class="item visibility-hide"></div>
      </div>
    </div>

    <div class="start-game">
      <el-button v-if="steps[step].countDown" type="primary">{{
        $t("test.btnStartGame")
      }}</el-button>
    </div>

    <div class="control-step">
      <div>
        <el-button
          @click="backStep"
          v-if="step > 0 && step < steps.length - 1"
          type="text"
          ><i class="fas fa-angle-left"></i>
          {{ $t("tutorial.btnBack") }}</el-button
        >
      </div>
      <div v-if="step < steps.length - 1">
        <el-button @click="$emit('exitTutorial')" type="text"
          >{{ $t("tutorial.btnSkip") }} <i class="fas fa-angle-right"></i
          ><i class="fas fa-angle-right"></i
        ></el-button>
        <el-divider direction="vertical"></el-divider>
        <el-button @click="nextStep" type="text"
          >{{ $t("tutorial.btnNext") }} <i class="fas fa-angle-right"></i
        ></el-button>
      </div>
      <div v-else>
        <el-button @click="$emit('exitTutorial')" type="text"
          >{{ $t("test.btnStartGame") }} <i class="fas fa-angle-right"></i
        ></el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pattern: {
      type: Object,
      default: null,
    },
  },
  computed: {
    gradient() {
      return {
        background: `conic-gradient(#FF9B57 0%, #FF9B57 ${
          this.steps[this.step].countDown * 10
        }%, #FFDAC1 ${this.steps[this.step].countDown * 10}%, #FFDAC1 0%)`,
      };
    },
  },
  data() {
    return {
      step: 0,
      steps: [
        {
          step: 0,
          positions: [
            { row: 1, column: 1, number: 3 },
            { row: 1, column: 3, number: 1 },
            { row: 3, column: 2, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step0"),
          countDown: 10,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 1,
          positions: [
            { row: 1, column: 1, number: 3 },
            { row: 1, column: 3, number: 1 },
            { row: 3, column: 2, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step1"),
          countDown: 6,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 2,
          positions: [
            { row: 1, column: 1, number: 3 },
            { row: 1, column: 3, number: 1 },
            { row: 3, column: 2, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step2"),
          countDown: 3,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 3,
          positions: [
            { row: 1, column: 1, number: 3 },
            { row: 1, column: 3, number: 1 },
            { row: 3, column: 2, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step3"),
          countDown: 1,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 4,
          positions: [
            { row: 1, column: 1, number: null },
            { row: 1, column: 3, number: null },
            { row: 3, column: 2, number: null },
          ],
          description: this.$t("tutorialNumberSequences.step4"),
          countDown: null,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 5,
          positions: [
            { row: 1, column: 1, number: null },
            { row: 1, column: 3, number: null },
            { row: 3, column: 2, number: null },
          ],
          description: this.$t("tutorialNumberSequences.step5"),
          countDown: null,
          lifePoints: 3,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 6,
          positions: [
            { row: 1, column: 1, number: null },
            { row: 1, column: 3, number: null },
            { row: 3, column: 2, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step6"),
          countDown: null,
          lifePoints: 2,
          fail: {
            row: 3,
            column: 2,
          },
        },
        {
          step: 7,
          positions: [
            { row: 1, column: 1, number: null },
            { row: 1, column: 3, number: 1 },
            { row: 3, column: 2, number: null },
          ],
          description: this.$t("tutorialNumberSequences.step7"),
          countDown: null,
          lifePoints: 2,
          fail: {
            row: null,
            column: null,
          },
        },

        {
          step: 8,
          positions: [
            { row: 1, column: 1, number: null },
            { row: 1, column: 3, number: 1 },
            { row: 3, column: 2, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step8"),
          countDown: null,
          lifePoints: 0,
          fail: {
            row: 1,
            column: 1,
          },
        },
        {
          step: 9,
          positions: [
            { row: 1, column: 2, number: 1 },
            { row: 2, column: 1, number: 3 },
            { row: 3, column: 3, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step9"),
          countDown: null,
          lifePoints: 1,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 10,
          positions: [
            { row: 1, column: 2, number: null },
            { row: 2, column: 1, number: null },
            { row: 3, column: 3, number: null },
          ],
          description: this.$t("tutorialNumberSequences.step10"),
          countDown: null,
          lifePoints: 1,
          fail: {
            row: null,
            column: null,
          },
        },
        {
          step: 11,
          positions: [
            { row: 1, column: 2, number: 1 },
            { row: 2, column: 1, number: 3 },
            { row: 3, column: 3, number: 2 },
          ],
          description: this.$t("tutorialNumberSequences.step11"),
          countDown: null,
          lifePoints: 1,
          fail: {
            row: null,
            column: null,
          },
        },
      ],
    };
  },
  methods: {
    nextStep() {
      this.step++;
      this.$emit("setLifePoints", this.steps[this.step].lifePoints);
    },
    backStep() {
      this.step--;
      this.$emit("setLifePoints", this.steps[this.step].lifePoints);
    },
    skip() {
      this.$emit("exitTutorial");
    },
    isNumber(row, column) {
      let find = this.steps[this.step].positions.find(
        (f) => f.row == row && f.column == column && f.number
      );
      return typeof find !== "undefined" ? find.number : null;
    },
    isMarked(row, column) {
      let find = this.steps[this.step].positions.find(
        (f) => f.row == row && f.column == column
      );
      return typeof find !== "undefined" ? true : false;
    },

    isFail(row, column) {
      if (
        this.steps[this.step].fail.row == row &&
        this.steps[this.step].fail.column == column &&
        !this.steps[this.step].fail.correct
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.pattern-block {
  background-color: #fff;
  border-radius: 32px;
  height: 74vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;

  @media screen and (max-width: 1600px) {
    height: 70vh;
  }

  @media screen and (max-width: 1280px) {
    height: 67vh;
  }

  @media screen and (max-width: 1199px) {
    height: 67vh;
  }

  @media screen and (max-width: 1100px) {
    height: 76vh;
  }

  @media screen and (max-width: 918px) {
    height: 81vh;
  }

  @media screen and (max-width: 500px) {
    height: calc(100vh - 115px);
    padding: 10px;
  }
}
</style>